import { Link, useLocation } from 'react-router';
import { Icon } from '../ui/Icon';
import { useAppStore } from './store';
import { TABS, tabOf } from './tabs';
import styles from './Shell.module.css';

/**
 * Dig · Drums · Beat · Learn · More. Each tab reopens its own last sub-view;
 * tapping the current tab again goes to its home.
 */
export function BottomNav() {
  const { pathname } = useLocation();
  const tabPaths = useAppStore((s) => s.continuity.tabPaths);
  const current = tabOf(pathname);

  return (
    <nav className={styles.nav} aria-label="Main">
      <ul className={styles.navList}>
        {TABS.map((t) => {
          const to = t.id === current ? t.home : (tabPaths[t.id] ?? t.home);
          return (
            <li key={t.id}>
              <Link
                to={to}
                className={styles.navLink}
                aria-current={t.id === current ? 'page' : undefined}
              >
                <Icon icon={t.icon} />
                {t.label}
              </Link>
            </li>
          );
        })}
      </ul>
    </nav>
  );
}
